import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";

const useStyles = makeStyles((theme) => ({
  sectionContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    margin: "1rem 0rem 1rem 0rem",
  },
  heading: {
    width: "100%",
    color: "#0FCA56",
    // background: "linear-gradient(to right, #0FCA56 0%, #08A945 100%)",
    // WebkitBackgroundClip: "text",
    // WebkitTextFillColor: "transparent",
    fontWeight: "600",
    fontSize: "1.75rem",
    lineHeight: "3.1875rem",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    margin: "0rem 0rem 0.5rem 0rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.5rem",
      lineHeight: "2.25rem",
    },
  },
  text: {
    margin: "0.5rem 0rem 0.5rem 0rem",
    width: "100%",
    color: "#666666",
    fontWeight: "400",
    fontSize: "1rem",
    lineHeight: "1.75rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.125rem",
      lineHeight: "1.6875rem",
    },
  },
}));

const Terms = () => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <div className={classes.sectionContainer}>
        <Typography variant="h6" component="span" className={classes.heading}>
          TERMS OF USE
        </Typography>
        <Typography variant="body2" component="span" className={classes.text}>
          These Terms of Use (&quot;<b>Terms of Use</b>&quot;) when accepted by
          You becomes an agreement between the Company and You regarding the use
          of the Online Platform. You agree to be bound by these Terms of Use by
          continuing to access the Online Platform or obtaining the Services.
        </Typography>
        <Typography variant="body2" component="span" className={classes.text}>
          The Company reserves the right to modify these Terms of Use without
          Your consent. You are expected to check for revisions to the Terms of
          Use regularly as they are binding on you. The “Last Revised” date at
          the bottom of the Terms of Use indicates when the modifications to the
          Terms of Use were made. Any use of the Services subsequent to modified
          Terms of Use coming into force implies acceptance of the modified
          Terms of Use.
        </Typography>

        <Typography variant="body2" component="span" className={classes.text}>
          <li>
            The content of this website is for general information purposes
            only. While enough care is taken by Sentient Developers Private
            limited (‘Sentient’) to ensure that information on the website is up
            to date, accurate and correct, readers are requested to make their
            independent enquiry before relying upon the same. In no event will
            Sentient offer any warranty on the information made available or be
            liable for any loss or damage including without limitation, indirect
            or consequential loss or damage in connection with, the use of
            information in this website. By using or accessing the website, you
            agree with the Disclaimer without any qualification or limitation.
          </li>
        </Typography>
        <Typography variant="body2" component="span" className={classes.text}>
          <li>
            The information depicted herein viz., master plans, floor plans,
            furniture layout, fittings, illustrations, specifications, designs,
            dimensions, rendered views, colours, amenities and facilities etc.,
            are subject to change without notifications as may be required by
            the relevant authorities or the developer’s architect, and cannot
            form part of an offer or contract. Whilst every care is taken in
            providing this information, the developer cannot be held liable for
            variations. All illustrations and pictures are artist’s impression
            only. The information is subject to variations, additions,
            deletions, substitutions and modifications as may be recommended by
            the company’s architect and/or the relevant approving authorities.
            The Developer is wholly exempt from any liability on account of any
            claim in this regard. (1 square metre = 10.764 square feet). All
            dimensions and calculations are done in metric system (M / Sq. m),
            and imperial system (Ft / Sq. Ft) shown is for reference only.
          </li>
        </Typography>
        <Typography variant="body2" component="span" className={classes.text}>
          <li>
            The contents of this website are meant to provide information to the
            readers of this website about ourselves including our various
            projects, various initiatives taken by us, CSR activities etc. They
            are only for general information and are subject to change. By no
            stretch of imagination, the information on the website shall be
            construed as an advertisement and/or invitation or offer for sale.
          </li>
        </Typography>
        <Typography variant="body2" component="span" className={classes.text}>
          <li>
            Please note that by sharing any of your contact details on the
            website, you are authorizing Sentient (even if you are registered on
            the DND Registry) to provide information on our projects over Calls,
            SMS &amp; Emails.
          </li>
        </Typography>
      </div>
    </React.Fragment>
  );
};

export default Terms;
